document.addEventListener('DOMContentLoaded', function() {
  var AssessmentVariantId = '44440992252061';

  var cartAddEndpoint = theme.routes.cartAdd;

  if (cartAddEndpoint === undefined) {
    logError('No cart add endpoint')
    return;
  }

  var buyNowBtn = document.querySelector('.loopable-buy-now')
  var addToCartBtn = document.querySelector('.add-to-cart')
  var assessmentCheckbox = document.getElementById('loopable-assessment');

  var addToCart = async function (addData, originalEvent) {
    try {
      log('Adding to cart', addData)

      var res = await fetch(cartAddEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(addData)
      })

      log('Successfully added to cart', res)

      if (originalEvent !== undefined) {
        // Continue original submission
        var customEvent = new CustomEvent('click', {
          bubbles: originalEvent.bubbles,
          cancelable: originalEvent.cancelable,
          detail: { dispatched: true },
        })
        originalEvent.target.dispatchEvent(customEvent);

        log('Dispatched custom event')
      }
    } catch (err) {
      logError('Error adding to cart', err)
    }
  }

  // Add to cart and redirect to checkout
  buyNowBtn.addEventListener('click', function (e) {
    e.preventDefault()
    e.stopPropagation()

    var initialProductVariantId = e.target.dataset['variant-id']

    var params = new URLSearchParams(window.location.search);
    var dynamicProductVariantId = params.get('variant')

    var productVariantId = dynamicProductVariantId !== null ?
      dynamicProductVariantId : initialProductVariantId;

    var hasAddOn = assessmentCheckbox.checked

    ;(async function() {
      var addData = {
        'items': [
          ...(hasAddOn ? [{ id: AssessmentVariantId, quantity: 1 }] : []),
          { id: productVariantId, quantity: 1 },
        ]
      };
      await addToCart(addData)

      window.location.href = '/checkout'
    })()
  })

  // Add to cart and dispatch original event (so the client-side cart
  // can update, etc...)
  addToCartBtn.addEventListener('click', function (e) {
    var hasAddOn = assessmentCheckbox.checked

    if (hasAddOn && (!e.detail || !e.detail.dispatched)) {
      e.preventDefault()
      e.stopPropagation()

      ;(async function () {
        var addData = {
          'items': [
            { id: AssessmentVariantId, quantity: 1 },
          ]
        };
        await addToCart(addData, e)
      })();
    }
  })

  // Utility functions

  function log(...args) {
    console.log('Loopable', ...args);
  }

  function logError(...args) {
    console.error('Loopable', ...args);
  }
})
